import { component } from 'picoapp'

export default component(node => {
  const countrySelector = node.querySelector('[data-country]')
  const provinceSelector = node.querySelector('[data-province]')
  const provinceContainer = node.querySelector('[data-provice-container]')
  var countryDefault = countrySelector.getAttribute('data-default') ? countrySelector.getAttribute('data-default') : countrySelector.options[0].innerText
  var provinceDefault = provinceSelector.getAttribute('data-default')

  /**
   * Select an option within a <select>
   * based on a given value
   *
   * @param {string} value Value to search for
   * @param {element} select <select> element
   * @return {element} The first matching select option
   */
  function selectOption(value, select){
    return Array.prototype.slice.call(select.options).filter(function(option, i){
      if (option.innerText === value){
        select.selectedIndex = i
        return true
      }
      return false
    })[0]
  }

  /**
   * Generate province options and show select element
   *
   * @param {array} options Array of arrays from selected country
   */
  function showProvinces(options){
    var previousValue = provinceSelector.options[0] ? provinceSelector.options[0].value : false
    var isNewValue = !previousValue || options[0][0] !== previousValue ? true : false

    if (isNewValue){
      // Emptry provinces select
      provinceSelector.innerHTML = ''

      // Generate new options from values
      for (var i = 0; i < options.length; i++){
        var option = document.createElement('option')
        option.value = options[i][0]
        option.innerHTML = options[i][1]
        provinceSelector.appendChild(option)
      }
    }

    // Select the default province
    if (provinceDefault.length > 0) selectOption(provinceDefault, provinceSelector)

    // Show provinces
    provinceContainer.style.display = '';
  }

  /**
   * Hide provinces container
   */
  function hideProvinces(){
    provinceContainer.style.display = 'none';
  }

  /**
   * If we have an active default country,
   * select it and select it's default province
   *
   * (this is for the edit form)
   */
  function selectDefaults(){
    if (countryDefault.length < 1) return
    var selectedCountry = selectOption(countryDefault, countrySelector)
    var options = JSON.parse(selectedCountry.getAttribute('data-provinces'))

    showProvinces(options)
  }

  /**
   * Get selected country, read it's
   * provinces, and toss them into the
   * provinces selector
   */
  countrySelector.onchange = function(){
    check()
  }

  function check() {
    var selectedCountry = countrySelector.options[countrySelector.selectedIndex]
    var options = JSON.parse(selectedCountry.getAttribute('data-provinces')) || []
    options.length > 0 ? showProvinces(options) : hideProvinces()
  }

  selectDefaults()
  check()
})